import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import SiteHeader from './SiteHeader.jsx';
import SiteFooter from './SiteFooter.jsx';
import { useSeo } from '../hooks/useSeo.js';

// Full bright content page: site header, a titled container, and footer.
// Used by the legal/info pages.
export default function PageShell({ title, intro, children }) {
  const navigate = useNavigate();
  useSeo(
    `${title} — QuizzyLoot`,
    intro || `${title} for QuizzyLoot, the free trivia game.`,
  );
  return (
    <div className="min-h-screen flex flex-col page-in">
      <SiteHeader variant="light" />

      <main className="flex-1 mx-auto w-full max-w-3xl px-4 sm:px-6 py-10">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 text-sm font-bold text-slate-500 hover:text-brand transition-colors mb-6"
        >
          <IoArrowBack /> Back
        </button>

        <h1 className="text-3xl sm:text-4xl font-black text-slate-900">{title}</h1>
        {intro && <p className="mt-2 text-slate-500">{intro}</p>}

        <div className="mt-8">{children}</div>
      </main>

      <SiteFooter />
    </div>
  );
}
